exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2WRfVH4Uv9smd77rXn4Cwn, ._19P1qSn5YKZwOq66_le0Oq {\n  color: #757575; }\n\n._19P1qSn5YKZwOq66_le0Oq:hover {\n  color: #4f5051; }\n\n._3NTo01EsApgZhn8H0U8Gxs {\n  color: #D50000; }\n  ._3NTo01EsApgZhn8H0U8Gxs:hover {\n    color: #a41701; }\n\n._2uH1p0_WzNdyyHyrMk35SD {\n  color: #CE4A00; }\n  ._2uH1p0_WzNdyyHyrMk35SD:hover {\n    color: #9b4400; }\n\n.XoORXobfY1ZWjUV-msgQn {\n  color: #2E7D32; }\n  .XoORXobfY1ZWjUV-msgQn:hover {\n    color: #225528; }\n", ""]);

// exports
exports.locals = {
	"greyIconBase": "_2WRfVH4Uv9smd77rXn4Cwn",
	"icon": "_19P1qSn5YKZwOq66_le0Oq",
	"stopIconFlag": "_3NTo01EsApgZhn8H0U8Gxs",
	"yellowFlagIcon": "_2uH1p0_WzNdyyHyrMk35SD",
	"greenFlagIcon": "XoORXobfY1ZWjUV-msgQn"
};